import { render, staticRenderFns } from "./marketMySold.vue?vue&type=template&id=68a0a404&scoped=true"
import script from "./marketMySold.vue?vue&type=script&lang=js"
export * from "./marketMySold.vue?vue&type=script&lang=js"
import style0 from "./marketMySold.vue?vue&type=style&index=0&id=68a0a404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a0a404",
  null
  
)

export default component.exports